<template>
  <div class="dd-aa">
    <van-nav-bar
      title="幸运抽奖"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <main class="lottery-page">
      <section class="wheel-card">
        <div class="wheel-title">
          <span>LUCKY DRAW</span>
          <h1>幸运大转盘</h1>
          <p>点击转盘中心 GO 开始抽奖</p>
        </div>
        <div class="wheel-stage">
          <Zz
            v-if="prizes.length > 0"
            ref="LuckDraw"
            :config="config"
            :prizes="prizes"
            :btnConfig="btnConfig"
            @start="startCallBack"
            @end="endCallBack"
          />
        </div>
        <div class="chance-pill">
          剩余抽奖次数 <strong>{{ objU.remaining_times || 0 }}</strong> 次
        </div>
      </section>

      <section class="prize-card">
        <div class="section-heading">
          <span>PRIZE LIST</span>
          <h2>本期奖项说明</h2>
          <p>所有奖项均以本页面实时展示为准</p>
        </div>
        <div class="prize-table">
          <div class="prize-row prize-header">
            <span>奖项</span>
            <span>奖励内容</span>
            <span>发放说明</span>
          </div>
          <div
            v-for="(item, index) in tablePrizes"
            :key="item.id || index"
            class="prize-row"
          >
            <template v-if="isParticipationPrize(item)">
              <span class="participation-message">感谢参与</span>
            </template>
            <template v-else>
              <span class="prize-rank">{{ item.name || `奖项${index + 1}` }}</span>
              <span class="prize-value">{{ formatPrize(item) }}</span>
              <span class="prize-note">{{ prizeNote(item) }}</span>
            </template>
          </div>
        </div>
      </section>

      <section class="rule-card">
        <div class="rule-icon">i</div>
        <div>
          <h3>抽奖规则</h3>
          <p>{{ lotteryRuleText }}</p>
        </div>
      </section>

      <button @click="wayLists" class="record-button van-button van-button--round">
        <span>查看我的中奖记录</span>
      </button>
    </main>
    <van-popup
      v-model="show"
      round
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div style="height: 50px"></div>
      <div
        v-if="lists.length > 0"
        style="height: calc(100% - 50px);overflow: auto"
      >
        <van-cell-group>
          <van-cell
            v-for="item in lists"
            :key="item.key"
            :title="item.jiang_name"
            :value="item.addtime"
          />
        </van-cell-group>
      </div>
      <van-empty
        style="height: calc(100% - 50px);overflow: auto"
        v-else
        description="暂无记录"
      />
    </van-popup>
  </div>
</template>

<script>
import Zz from "@components/Zz";
import request from "@utils/request";
import zhi from "@assets/images/h/zp3_btn1.png";
import zhi2 from "@assets/images/h/zp3_btn2.png";
import icon2 from "@assets/images/h/xyzp-pan.png";
import fallbackGift from "@assets/images/gift.png";
import Vue from "vue";
import { Popup } from "vant";
import { Empty } from "vant";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Empty);
Vue.use(Popup);

const fallbackPrizeData = [
  { id: "default-1", name: "特等奖", num: "8888", rewardType: "USD礼金" },
  { id: "default-2", name: "一等奖", num: "3888", rewardType: "USD礼金" },
  { id: "default-3", name: "二等奖", num: "1888", rewardType: "USD礼金" },
  { id: "default-4", name: "三等奖", num: "888", rewardType: "USD礼金" },
  { id: "default-5", name: "四等奖", num: "588", rewardType: "USD礼金" },
  { id: "default-6", name: "五等奖", num: "88", rewardType: "USD礼金" },
  { id: "default-7", name: "六等奖", num: "8.8", rewardType: "USD礼金" },
  { id: "default-8", name: "感谢参与", num: "", rewardType: "" }
];

function buildPrize(item, index) {
  const participation = isParticipationData(item);
  const enabled = Number(item.status === undefined ? 1 : item.status) === 1;
  return {
    id: item.id,
    name: participation ? "感谢参与" : item.name,
    num: participation ? "" : item.num,
    rewardType: participation ? "" : (item.reward_type || item.rewardType || ""),
    index,
    sourceIndex: index,
    enabled,
    fonts: { text: participation ? "感谢参与" : (item.name || `奖项${index + 1}`), top: "84%" },
    imgs: { src: item.imgs || fallbackGift, width: "48%", top: "59%" },
    background: index % 2 === 0 ? "#FEF3FC" : "#F8DEF8",
    proba: item.proba || 0
  };
}

function isParticipationData(item) {
  const text = `${item && item.name || ""} ${item && item.num || ""} ${item && (item.reward_type || item.rewardType) || ""}`;
  return text.includes("参与") || text.includes("谢谢") || text.includes("感谢");
}

function swapSpecialAndThird(prizes) {
  const specialIndex = prizes.findIndex(item => String(item.name).includes("特等奖"));
  const thirdIndex = prizes.findIndex(item => String(item.name).includes("三等奖"));
  if (specialIndex >= 0 && thirdIndex >= 0) {
    const temp = prizes[specialIndex];
    prizes.splice(specialIndex, 1, prizes[thirdIndex]);
    prizes.splice(thirdIndex, 1, temp);
  }
  prizes.forEach((item, index) => {
    item.background = index % 2 === 0 ? "#FEF3FC" : "#F8DEF8";
  });
  return prizes;
}

export default {
  name: "zhuanpan",
  components: { Zz },
  computed: {
    tablePrizes() {
      return (this.prizes || [])
        .slice()
        .sort((a, b) => Number(a.sourceIndex) - Number(b.sourceIndex));
    },
    lotteryRuleText() {
      const configuredRule = String((this.objU && this.objU.rule) || "").trim();
      const hasDisabledPrizes = (this.prizes || []).some(item => item.enabled === false);
      const statusRule = hasDisabledPrizes
        ? " 页面展示包含活动奖项，实际参与抽奖的奖项以后台当前启用状态为准。"
        : "";
      if (configuredRule) {
        return `${configuredRule}${statusRule}`;
      }
      const rechargeAmount = Number(this.objU.recharge_amount) || 500;
      return `每累计充值 ${rechargeAmount} USD 获得 1 次机会，现金礼金中奖后可进入可提现余额。${statusRule}`;
    }
  },
  data() {
    return {
      nums: [],
      prizes: swapSpecialAndThird(fallbackPrizeData.map(buildPrize)),
      config: {
        width: 320,
        height: 320,
        padding: 36,
        fontSize: "11px",
        fontColor: "#000",
        backgroundColor: "rgba(0, 0, 0, 0)",
        backgroundImage: icon2
        // backgroundSize: '100% 100%'
      },
      btnConfig: {
        width: "92",
        background: "rgba(0,0,0,0)",
        imgs: [
          { src: zhi, width: "120px", top: "50%" },
          { src: zhi2, width: "40px", top: "100%" }
        ]
      },
      objU: {},
      show: false,
      lists: [],
      currentReward: null
    };
  },
  mounted() {
    const colors = ["#FEF3FC", "#F8DEF8"];
    request.get("/user/user/zpanindex").then(response => {
      const data = (response.data && response.data.data) || {};
      console.log("-> data", data);
      this.objU = data;
      if (Array.isArray(data.zhpan) && data.zhpan.length > 0) {
        this.nums = data.zhpan.map(v => v.proba);
        this.prizes = swapSpecialAndThird(data.zhpan.map((v, i) => {
          const prize = buildPrize(v, i);
          prize.background = i % 2 === 0 ? colors[0] : colors[1];
          prize.imgs.width = v.imgs ? "75%" : "48%";
          return prize;
        }));
      }
      console.log("->  this.prizes", this.prizes);
    });
  },
  methods: {
    isParticipationPrize(item) {
      return isParticipationData(item);
    },
    formatPrize(item) {
      const value = item.num === undefined || item.num === null ? "" : item.num;
      const type = item.rewardType || "";
      if (!value && !type) return "以奖品展示为准";
      const isCash = this.isCashPrize(item);
      const unit = isCash &&
        value &&
        !`${value} ${type}`.toUpperCase().includes("USD")
        ? " USD"
        : "";
      return `${value}${unit}${type ? ` ${type}` : ""}`.trim();
    },
    isCashPrize(item) {
      const type = String(item.rewardType || "").toLowerCase();
      const name = String(item.name || "");
      return type.includes("money") ||
        type.includes("cash") ||
        type.includes("现金") ||
        type.includes("礼金") ||
        name.includes("现金礼金");
    },
    prizeNote(item) {
      const type = String(item.rewardType || "").toLowerCase();
      const name = String(item.name || "");
      if (
        type.includes("实物") ||
        type.includes("礼品") ||
        type.includes("physical") ||
        type.includes("product") ||
        name.includes("实物礼品")
      ) {
        return "中奖后请联系客服登记邮寄";
      }
      if (this.isCashPrize(item)) {
        return "中奖后进入可提现余额";
      }
      if (type.includes("integral") || name.includes("积分")) {
        return "中奖后自动计入积分账户";
      }
      if (name.includes("谢谢") || name.includes("参与")) {
        return "感谢参与";
      }
      return "中奖后自动发放到账";
    },
    // 中间记录
    wayLists() {
      console.log("-> 1", 1);
      this.show = true;
      request.get("/user/user/jianglist").then(res => {
        console.log("-> res", res);
        this.lists = res.data.data || [];
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 随机
    getResult(arr) {
      let leng = 0;
      for (let i = 0; i < arr.length; i++) {
        leng += arr[i]; //获取总数
      }
      for (let i = 0; i < arr.length; i++) {
        var random = parseInt(Math.random() * leng); //获取 0-总数 之间的一个随随机整数
        if (random < arr[i]) {
          return i; //如果在当前的概率范围内,得到的就是当前概率
        } else {
          leng -= arr[i]; //否则减去当前的概率范围,进入下一轮循环
        }
      }
    },
    async startCallBack() {
      if (Number(this.objU.remaining_times || 0) <= 0) {
        this.$dialog.error("暂无抽奖次数，请先完成充值");
        this.unlockDraw();
        return false;
      }
      let data;
      try {
        const response = await request.get("user/user/chouj");
        data = response.data;
      } catch (error) {
        this.$dialog.error("抽奖请求失败，请稍后重试");
        this.unlockDraw();
        return false;
      }
      console.log("-> data111", data);
      if (data.code === 300) {
        this.$dialog.error(data.msg);
        this.unlockDraw();
        return false;
      }
      this.currentReward = data.data.reward || null;
      this.objU.remaining_times = data.data.remaining_times;
      this.objU.integral = data.integral;
      const sourceIndex = Number(data.data.index);
      const rewardId = data.data.reward && data.data.reward.id;
      const displayIndex = this.prizes.findIndex(item =>
        rewardId !== undefined && rewardId !== null
          ? String(item.id) === String(rewardId)
          : Number(item.sourceIndex) === sourceIndex
      );
      this.$refs.LuckDraw.play((displayIndex >= 0 ? displayIndex : sourceIndex) + 1);
    },
    unlockDraw() {
      this.$nextTick(() => {
        if (this.$refs.LuckDraw) {
          this.$refs.LuckDraw.haveClick = false;
        }
      });
    },
    endCallBack(inx) {
      const prize = this.prizes[inx] || {};
      const reward = this.currentReward || {};
      if (this.isParticipationPrize(prize) || isParticipationData(reward)) {
        alert("感谢参与");
        return;
      }
      const name = reward.name || prize.name || "幸运奖励";
      const value = reward.num || prize.num || "";
      const type = prize.rewardType ? `（${prize.rewardType}）` : "";
      const unit = this.isCashPrize(prize) &&
        value &&
        !`${value} ${prize.rewardType || ""}`.toUpperCase().includes("USD")
        ? " USD"
        : "";
      alert(`恭喜你获得：${name} ${value}${unit}${type}`);
    }
  }
};
</script>

<style scoped>
.dd-aa {
  min-height: 100vh;
  padding-bottom: 28px;
  background:
    radial-gradient(circle at 15% 8%, rgba(255, 225, 151, 0.45), transparent 28%),
    linear-gradient(180deg, #f4f0ff 0, #fbf9ff 42%, #f7f7fb 100%);
  text-align: center;
  margin: 0;
}

.lottery-page {
  width: min(100%, 430px);
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.wheel-card {
  padding: 22px 8px 20px;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 47%, rgba(255, 221, 119, 0.24), transparent 37%),
    linear-gradient(145deg, #512a91, #7544b4 56%, #a24e91);
  border-radius: 24px;
  box-shadow: 0 16px 35px rgba(73, 42, 133, 0.22);
}

.wheel-title span,
.section-heading span {
  color: #f7d987;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
}

.wheel-title h1 {
  margin: 6px 0 3px;
  color: #fff;
  font-size: 24px;
}

.wheel-title p {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.wheel-stage {
  display: flex;
  min-height: 330px;
  align-items: center;
  justify-content: center;
  margin: 4px auto 0;
}

.chance-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 18px;
  color: #fff6d8;
  font-size: 13px;
  background: rgba(39, 15, 76, 0.33);
  border: 1px solid rgba(255, 233, 170, 0.23);
  border-radius: 999px;
}

.chance-pill strong {
  color: #ffd76f;
  font-size: 18px;
}

.prize-card {
  margin-top: 14px;
  padding: 19px 13px 14px;
  background: #fff;
  border: 1px solid #eee8fa;
  border-radius: 20px;
  box-shadow: 0 10px 28px rgba(65, 42, 109, 0.08);
}

.section-heading h2 {
  margin: 5px 0 3px;
  color: #35264d;
  font-size: 19px;
}

.section-heading p {
  margin: 0 0 14px;
  color: #9a92a7;
  font-size: 11px;
}

.prize-table {
  overflow: hidden;
  border: 1px solid #eee9f6;
  border-radius: 13px;
}

.prize-row {
  display: grid;
  grid-template-columns: 0.9fr 0.8fr 1.45fr;
  align-items: center;
  min-height: 45px;
  color: #655c70;
  font-size: 11px;
  line-height: 1.4;
  background: #fff;
  border-bottom: 1px solid #f0ecf6;
}

.prize-row:nth-child(odd):not(.prize-header) {
  background: #fbf9ff;
}

.prize-row:last-child {
  border-bottom: 0;
}

.prize-row span {
  padding: 8px 5px;
  text-align: center;
  word-break: break-word;
}

.prize-row .participation-message {
  grid-column: 1 / -1;
  color: #8a5b23;
  font-weight: 800;
  letter-spacing: 1px;
}

.prize-header {
  min-height: 37px;
  color: #fff;
  font-weight: 700;
  background: linear-gradient(90deg, #6840a2, #8f4f9d);
}

.prize-rank {
  color: #4e326f;
  font-weight: 700;
}

.prize-value {
  color: #d28418;
  font-weight: 800;
}

.prize-note {
  color: #777080;
}

.rule-card {
  display: flex;
  gap: 11px;
  margin-top: 14px;
  padding: 16px;
  color: #665b72;
  text-align: left;
  background: linear-gradient(135deg, #fffaf0, #fff 75%);
  border: 1px solid #f2e5c5;
  border-radius: 18px;
}

.rule-icon {
  display: grid;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  place-items: center;
  color: #fff;
  font-weight: 800;
  background: #d9a337;
  border-radius: 50%;
}

.rule-card h3 {
  margin: 1px 0 7px;
  color: #4b3b58;
  font-size: 15px;
}

.rule-card p {
  margin: 0 0 5px;
  font-size: 12px;
  line-height: 1.65;
}

.record-button {
  width: 72%;
  height: 44px;
  margin-top: 17px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(90deg, #6840a2, #9a5092);
  border: 0;
  box-shadow: 0 9px 20px rgba(104, 64, 162, 0.22);
}

@media (max-width: 350px) {
  .wheel-stage {
    margin-left: -8px;
    margin-right: -8px;
    transform: scale(0.92);
  }
}
</style>

